import _ from 'lodash';
import $ from 'jquery';
import React, { Component } from 'react';
import Input from '../shared/Input';
import Tabs from '../shared/Tabs';
import Pane from '../shared/Pane';
import InvitationTable from './InvitationTable';
import { REGEX_EMAIL } from '../../toolbox/regex';
import {
  ADMIN,
  ADMIN_ID,
} from '../../constants/RoleConstants';
import {
  PENDING,
  ACCEPTED,
  DECLINED,
} from '../../constants/Status';
import i18n from '../../config/i18n';

const styles = {
  pane: {
    overflowY: 'auto',
    maxHeight: 320,
    tab: {
      label: {
        position: 'relative',
        top: -1,
        paddingBottom: '0.2em',
        marginLeft: 5,
      },
    },
  },
  select: {
    textIndent: 10,
    fontSize: 20,
  },
  button: {
    cancel: {
      marginRight: 10,
    },
  },
};

class Invitation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isValid: false,
      shouldRedirect: false,
      email: null,
      role: null,
      teamId: null,
    };
    this.onSubmit = this.onSubmit.bind(this);
    this.checkEmail = this.checkEmail.bind(this);
    this.onFormSelectChange = this.onFormSelectChange.bind(this);
  }

  componentDidMount() {
    const { actions } = this.props;
    actions.getInvitationList();
    actions.getAssignableRoles();
    actions.getJoinedTeamList();
  }

  onFormSelectChange(e) {
    const refName = e.target.name;
    const value = this[refName].value;
    const newProfile = _.assign({}, this.state.profile, { [refName]: value });
    this.setState({
      profile: newProfile,
    });
  }

  onSubmit = async (e) => {
    e.preventDefault();

    const { actions } = this.props;
    const isValid = this.state.isValid;

    if (isValid) {
      // Disable send invitation button
      this.setState({ isValid: false });

      const invitationData = {};
      _.each($(this.invitationForm).serializeArray(), (obj) => {
        invitationData[obj.name] = obj.value;
      });

      // if the invitee's role is ADMIN, we want to confirm before send out invitation
      // eslint-disable-next-line no-alert
      const isConfirmed = invitationData.role === ADMIN ? window.confirm(
        i18n.t('invitationMsg_admin', { invitationEmail: invitationData.email })
      ) : true;

      // submit form
      if (isConfirmed) {
        if (await actions.sendInvitation(invitationData)) {
          actions.createSuccessAlert(
            i18n.t('invitationMsg', { invitationEmail: this.state.email })
          );
          await actions.getInvitationList();
          this.email.reset();
          this.setState({ isValid: false });
        } else {
          this.setState({ isValid: true });
        }
      } else {
        this.setState({ isValid: true });
      }
    }
    return false;
  }

  /* Form related binding. */

  checkEmail(value, element) {
    const refName = element.name;
    const isValid = REGEX_EMAIL.test(value.trim());
    this.setState({
      [refName]: value,
      isValid,
    });
    return isValid;
  }

  /* Component render helpers. */

  generateTabs(data) {
    const panes = data.map((obj) => {
      const invitationLength = obj.invitations.length;
      const labelBadge = invitationLength === 0 ? obj.label : (
        <span>
          {obj.label}
          <span className="label label-success" style={styles.pane.tab.label}>
            {invitationLength}
          </span>
        </span>
      );

      return (
        <Pane
          key={obj.label}
          style={styles.pane}
          label={labelBadge}
        >
          <InvitationTable
            isLoading={obj.isLoading}
            invitations={obj.invitations}
            resendInvitation={this.props.actions.resendInvitation}
            canResend={obj.canResend}
          />
        </Pane>
      );
    });
    return (
      <Tabs selected={0}>
        {panes}
      </Tabs>
    );
  }

  generateRoleSelectOpt = assignableRoles => assignableRoles.map(roleName => (
    <option key={roleName} value={roleName}>{i18n.t(roleName)}</option>
  ));

  generateTeamSelectOpt = assignableTeams => assignableTeams.map(team => (
    <option key={team.name} value={team.id}>{team.name}</option>
  ));

  render() {
    const {
      invitation: {
        roles,
        invitations,
        isLoading,
      },
      user: {
        userId,
        teamList,
        profile: {
          roleId,
          currentTeamId,
        },
      },
    } = this.props;
    const roleOptions = this.generateRoleSelectOpt(roles);
    const teamOptions = this.generateTeamSelectOpt(teamList.filter(
      team => team.ownerId === parseInt(userId, 10)
    ));
    const activeInvitations = _.filter(invitations,
      localInvitation => localInvitation.status === PENDING);
    // TODO: revoke invitation feature is hidden for now.
    // const registeredInvitations =
    // _.filter(invitations, (localInvitation) => localInvitation.status === 'revoked');
    const expiredInvitations = _.filter(invitations,
      localInvitation => localInvitation.status === ACCEPTED);
    const declinedInvitations = _.filter(invitations,
      localInvitation => localInvitation.status === DECLINED);
    const tabData = [
      {
        label: i18n.t('pending'),
        isLoading,
        invitations: activeInvitations,
        canResend: true,
      },
      // {
      //   label: i18n.t('revoked'),
      //   isLoading,
      //   invitations: registeredInvitations,
      //   canResend: false,
      // },
      {
        label: i18n.t('accepted'),
        isLoading,
        invitations: expiredInvitations,
        canResend: false,
      },
      {
        label: i18n.t('declined'),
        isLoading,
        invitations: declinedInvitations,
        canResend: false,
      },
    ];
    const tabBlock = this.generateTabs(tabData);

    return (
      <div>
        <h2>
          {i18n.t('sendInvitation')}
        </h2>
        <p>
          {i18n.t('enterEmailAndRole')}
        </p>
        <p className="text-info">
          {i18n.t('invitationNotExpireMsg')}
        </p>
        <form
          ref={(ref) => { this.invitationForm = ref; }}
          onSubmit={this.onSubmit}
          autoComplete="off"
        >
          <div className="form-group">
            <label className="control-label" htmlFor="email">
              {i18n.t('email')}
            </label>
            <Input
              ref={(ref) => { this.email = ref; }}
              type="email"
              name="email"
              defaultValue=""
              placeholder="name@domain.com"
              errorMessage={i18n.t('invalidEmail')}
              required
              validate={this.checkEmail}
            />
          </div>
          <div className="form-group">
            <label className="control-label" htmlFor="role">
              {i18n.t('assignableRole')}
            </label>
            <select
              name="role"
              ref={(ref) => { this.role = ref; }}
              onChange={this.onFormSelectChange}
              className="form-control"
              style={styles.select}
              required
            >
              {roleOptions}
            </select>
          </div>
          {
            roleId !== ADMIN_ID && (
              <div className="form-group">
                <label className="control-label" htmlFor="teamId">
                  {i18n.t('assignableTeam')}
                </label>
                <select
                  name="teamId"
                  ref={(ref) => { this.teamId = ref; }}
                  onChange={this.onFormSelectChange}
                  className="form-control"
                  style={styles.select}
                  required
                  defaultValue={currentTeamId}
                >
                  {teamOptions}
                </select>
              </div>
            )
          }
          <div className="form-group clearfix">
            <button
              disabled={!this.state.isValid}
              className="btn btn-info pull-right"
            >
              {i18n.t('sendInvitation')}
            </button>
          </div>
        </form>
        <div className="form-group clearfix">
          <h2>
            {i18n.t('invitationList')}
          </h2>
          <p />
          {tabBlock}
        </div>
      </div>
    );
  }
}

export default Invitation;



// WEBPACK FOOTER //
// ./src/components/team/Invitation.js